import {DashboardPlugin} from "../../../core/plugin/PluginType";
import WorkDayRecordHistoryWidget from "./WorkDayRecordHistoryWidget";

const TimeRecordHistoryDashboardPlugin: DashboardPlugin = {
    id: 'my-time-record-history-widget',
    name: 'Zeiterfassungs-Verlauf',
    icon: 'clockHistory',
    version: '1.0.0',
    description: 'Displays the last time records with visual time scales and allows editing entries.',
    author: 'Your Company',
    type: 'dashboard',
    component: WorkDayRecordHistoryWidget,
    defaultSize: 'medium',
    isPinned: true,
    defaultPreferences: {},
    requiredPermissions: ['dashboard.plugins.time-record-history.view'],
};

export default TimeRecordHistoryDashboardPlugin;